<dx-text-box
    #googlePlacesAutocomplete
    stylingMode="underlined"
    [label]="label"
    labelMode="floating"
></dx-text-box>
